import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../ReportCategory";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";
import { Neo } from "@singularsystems/neo-react";
import CustomIssuerInvestmentCriteria from "./CustomIssuerInvestmentCriteria";

@NeoReport("CustomIssuerInvestmentReport", { category: ReportCategory.IssuerReports })
export default class CustomIssuerInvestmentReport extends Report<CustomIssuerInvestmentCriteria> {

    constructor(
        private dataCache = AppService.get(DomainTypes.Services.DataCache)
    ) {
        super(CustomIssuerInvestmentCriteria);
    }

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
            <Neo.FormGroup bind={this.criteria.meta.entityId} select={{ itemSource: this.dataCache.entities, allowNulls: true }} />
        </div>;
    }
}